import React, { useState } from 'react';
import { X, Camera, Plus, Trash2, Check } from 'lucide-react';
interface AddPropertyModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (property: any) => void;
}
export function AddPropertyModal({
  isOpen,
  onClose,
  onSave
}: AddPropertyModalProps) {
  const [formData, setFormData] = useState({
    name: '',
    address: '',
    city: 'Roma',
    zone: '',
    sqm: '',
    rooms: '',
    bathrooms: '',
    issues: ''
  });
  const [checklist, setChecklist] = useState(['Cambio biancheria', 'Pulizia bagni', 'Aspirapolvere', 'Cucina e elettrodomestici']);
  if (!isOpen) return null;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave({
      ...formData,
      sqm: Number(formData.sqm),
      rooms: Number(formData.rooms),
      bathrooms: Number(formData.bathrooms),
      checklist,
      issues: formData.issues ? [formData.issues] : [],
      status: 'Attiva',
      imageCount: 0,
      checkIn: null,
      checkOut: null
    });
    // Reset form
    setFormData({
      name: '',
      address: '',
      city: 'Roma',
      zone: '',
      sqm: '',
      rooms: '',
      bathrooms: '',
      issues: ''
    });
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" data-id="element-847">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm transition-opacity" onClick={onClose} data-id="element-848" />

      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] flex flex-col animate-in fade-in zoom-in-95 duration-200" data-id="element-849">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-850">
          <h2 className="text-xl font-bold font-montserrat text-navy" data-id="element-851">
            Nuova Proprietà
          </h2>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full text-gray-400 hover:text-navy transition-colors" data-id="element-852">
            <X size={20} data-id="element-853" />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-6" data-id="element-854">
          <form id="add-property-form" onSubmit={handleSubmit} className="space-y-6" data-id="element-855">
            {/* Basic Info */}
            <div className="space-y-4" data-id="element-856">
              <h3 className="text-sm font-semibold text-navy uppercase tracking-wider" data-id="element-857">
                Dettagli Principali
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-858">
                <div className="md:col-span-2" data-id="element-859">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-860">
                    Nome Proprietà
                  </label>
                  <input type="text" required placeholder="es. Appartamento Prati" className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-teal-deep focus:border-transparent outline-none" value={formData.name} onChange={e => setFormData({
                  ...formData,
                  name: e.target.value
                })} data-id="element-861" />
                </div>

                <div className="md:col-span-2" data-id="element-862">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-863">
                    Indirizzo
                  </label>
                  <input type="text" required placeholder="es. Via Cola di Rienzo 28" className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-teal-deep focus:border-transparent outline-none" value={formData.address} onChange={e => setFormData({
                  ...formData,
                  address: e.target.value
                })} data-id="element-864" />
                </div>

                <div data-id="element-865">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-866">
                    Città
                  </label>
                  <input type="text" required className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-teal-deep focus:border-transparent outline-none" value={formData.city} onChange={e => setFormData({
                  ...formData,
                  city: e.target.value
                })} data-id="element-867" />
                </div>

                <div data-id="element-868">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-869">
                    Zona
                  </label>
                  <input type="text" required placeholder="es. Prati" className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-teal-deep focus:border-transparent outline-none" value={formData.zone} onChange={e => setFormData({
                  ...formData,
                  zone: e.target.value
                })} data-id="element-870" />
                </div>
              </div>
            </div>

            {/* Specs */}
            <div className="space-y-4" data-id="element-871">
              <h3 className="text-sm font-semibold text-navy uppercase tracking-wider" data-id="element-872">
                Caratteristiche
              </h3>
              <div className="grid grid-cols-3 gap-4" data-id="element-873">
                <div data-id="element-874">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-875">
                    Mq
                  </label>
                  <input type="number" required placeholder="85" className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-teal-deep focus:border-transparent outline-none" value={formData.sqm} onChange={e => setFormData({
                  ...formData,
                  sqm: e.target.value
                })} data-id="element-876" />
                </div>
                <div data-id="element-877">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-878">
                    Camere
                  </label>
                  <input type="number" required placeholder="3" className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-teal-deep focus:border-transparent outline-none" value={formData.rooms} onChange={e => setFormData({
                  ...formData,
                  rooms: e.target.value
                })} data-id="element-879" />
                </div>
                <div data-id="element-880">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-881">
                    Bagni
                  </label>
                  <input type="number" required placeholder="2" className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-teal-deep focus:border-transparent outline-none" value={formData.bathrooms} onChange={e => setFormData({
                  ...formData,
                  bathrooms: e.target.value
                })} data-id="element-882" />
                </div>
              </div>
            </div>

            {/* Photos */}
            <div className="space-y-4" data-id="element-883">
              <h3 className="text-sm font-semibold text-navy uppercase tracking-wider" data-id="element-884">
                Galleria Fotografica
              </h3>
              <div className="border-2 border-dashed border-gray-300 rounded-xl p-8 flex flex-col items-center justify-center text-center hover:bg-gray-50 transition-colors cursor-pointer group" data-id="element-885">
                <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mb-3 group-hover:bg-white group-hover:shadow-sm transition-all" data-id="element-886">
                  <Camera className="text-gray-400 group-hover:text-teal-deep" size={24} data-id="element-887" />
                </div>
                <p className="text-sm font-medium text-navy" data-id="element-888">
                  Clicca per caricare foto
                </p>
                <p className="text-xs text-gray-500 mt-1" data-id="element-889">
                  JPG, PNG fino a 5MB
                </p>
              </div>
            </div>

            {/* Checklist */}
            <div className="space-y-4" data-id="element-890">
              <div className="flex items-center justify-between" data-id="element-891">
                <h3 className="text-sm font-semibold text-navy uppercase tracking-wider" data-id="element-892">
                  Checklist Pulizia Ordinaria
                </h3>
                <button type="button" className="text-xs font-medium text-teal-deep hover:text-teal-700 flex items-center gap-1" data-id="element-893">
                  <Plus size={14} data-id="element-894" /> Aggiungi attività
                </button>
              </div>
              <div className="space-y-2" data-id="element-895">
                {checklist.map((item, idx) => <div key={idx} className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg border border-gray-100" data-id="element-896">
                    <div className="w-5 h-5 rounded bg-teal-deep flex items-center justify-center flex-shrink-0" data-id="element-897">
                      <Check size={12} className="text-white" data-id="element-898" />
                    </div>
                    <span className="text-sm text-gray-700 flex-1" data-id="element-899">{item}</span>
                    <button type="button" className="text-gray-400 hover:text-red-500 transition-colors" data-id="element-900">
                      <Trash2 size={16} data-id="element-901" />
                    </button>
                  </div>)}
              </div>
            </div>

            {/* Issues */}
            <div className="space-y-4" data-id="element-902">
              <h3 className="text-sm font-semibold text-navy uppercase tracking-wider" data-id="element-903">
                Problemi Noti
              </h3>
              <textarea placeholder="Descrivi eventuali problemi già noti (es. rubinetto che perde, maniglia rotta)..." className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-teal-deep focus:border-transparent outline-none resize-none h-24" value={formData.issues} onChange={e => setFormData({
              ...formData,
              issues: e.target.value
            })} data-id="element-904" />
            </div>
          </form>
        </div>

        {/* Footer */}
        <div className="p-6 border-t border-gray-100 bg-gray-50 rounded-b-2xl flex justify-end gap-3" data-id="element-905">
          <button onClick={onClose} className="px-4 py-2.5 border border-gray-200 rounded-lg text-sm font-medium text-gray-600 hover:bg-white hover:text-navy transition-colors" data-id="element-906">
            Annulla
          </button>
          <button type="submit" form="add-property-form" className="px-6 py-2.5 bg-teal-deep text-white rounded-lg text-sm font-medium hover:bg-teal-deep/90 transition-colors shadow-sm" data-id="element-907">
            Salva Proprietà
          </button>
        </div>
      </div>
    </div>;
}